module.exports = __webpack_public_path__ + "KaTeX_Main-Italic.0ba24307.woff";